// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import VueI18n from 'vue-i18n'
import en from '../store/i18n/en'
import zhHans from '../store/i18n/zhHans'
import store from "@/store/index"
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)
Vue.use(VueI18n)
const messages = {
  en: en.en,
  zhHans: zhHans.zhHans,
}
const i18n = new VueI18n({
  locale: store.state.i18nLocale, // set locale
  messages, // set locale messages
})


const opts = {
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  breakpoint: {
    thresholds: {
      xs: 600,
    },
  },
}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js